import React, { useState } from 'react';
import './ContactForm.css';

const ContactForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    country: '',
    mobileNumber: '',
    email: '',
    cityName: '',
    lookingFor: '',
    netWorth: '',
    taxStatus: '',
    preferredDate: '',
    preferredTime: '',
    hearAboutUs: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Contact form submitted:', formData);
    alert('Thank you! We will get back to you soon.');
    onClose();
  };

  return (
    <div className="contact-overlay">
      <div className="contact-container">
        <button className="close-btn" onClick={onClose} type="button">
          ×
        </button>
        <div className="contact-header">
          <h2>Connect with an expert</h2>
        </div>
        
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-row">
            <div className="form-group full-width">
              <input
                type="text"
                name="fullName"
                placeholder="Full Name"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <select
                name="country"
                value={formData.country}
                onChange={handleChange}
                required
              >
                <option value="">-Select Country-</option>
                <option value="india">India</option>
                <option value="usa">USA</option>
                <option value="uk">UK</option>
                <option value="canada">Canada</option>
                <option value="australia">Australia</option>
              </select>
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="mobileNumber"
                placeholder="Mobile Number*"
                value={formData.mobileNumber}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group full-width">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group full-width">
              <input
                type="text"
                name="cityName"
                placeholder="City Name"
                value={formData.cityName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group full-width">
              <textarea
                name="lookingFor"
                placeholder="What are you looking for?"
                value={formData.lookingFor}
                onChange={handleChange}
                rows="3"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <select
                name="netWorth"
                value={formData.netWorth}
                onChange={handleChange}
              >
                <option value="">-Select Net Worth-</option>
                <option value="below-1l">Below ₹1 Lakh</option>
                <option value="1l-5l">₹1-5 Lakhs</option>
                <option value="5l-10l">₹5-10 Lakhs</option>
                <option value="10l-25l">₹10-25 Lakhs</option>
                <option value="25l-50l">₹25-50 Lakhs</option>
                <option value="50l-1cr">₹50 Lakhs - 1 Crore</option>
                <option value="above-1cr">Above ₹1 Crore</option>
              </select>
            </div>
            <div className="form-group">
              <select
                name="taxStatus"
                value={formData.taxStatus}
                onChange={handleChange}
              >
                <option value="">-Select Tax Status-</option>
                <option value="salaried">Salaried</option>
                <option value="business">Business Owner</option>
                <option value="freelancer">Freelancer</option>
                <option value="retired">Retired</option>
                <option value="student">Student</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="date"
                name="preferredDate"
                value={formData.preferredDate}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <select
                name="preferredTime"
                value={formData.preferredTime}
                onChange={handleChange}
              >
                <option value="">-Select Time-</option>
                <option value="9am-12pm">9:00 AM - 12:00 PM</option>
                <option value="12pm-3pm">12:00 PM - 3:00 PM</option>
                <option value="3pm-6pm">3:00 PM - 6:00 PM</option>
                <option value="6pm-9pm">6:00 PM - 9:00 PM</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group full-width">
              <select
                name="hearAboutUs"
                value={formData.hearAboutUs}
                onChange={handleChange}
              >
                <option value="">-How did you hear about us?-</option>
                <option value="google">Google Search</option>
                <option value="social-media">Social Media</option>
                <option value="referral">Friend/Family Referral</option>
                <option value="advertisement">Advertisement</option>
                <option value="website">Website</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <button type="submit" className="submit-btn">
            Request a callback
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;